import { useState, useEffect } from 'react';
import SearchableChipSelector from 'storybookConfig/stories/molecules/Input/SearchableChipSelector';
import { fetchStaticCategoryList } from '../../utils/googleCategories';

interface CategorySelectorProps {
  value: string[];
  onChange: (categories: string[]) => void;
  label: string;
}

const CategorySelector = ({ value, onChange, label }: CategorySelectorProps) => {
  const [rootCategories, setRootCategories] = useState<{ label: string; value: string }[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const result = await fetchStaticCategoryList();
        if (result?.trie) {
          // Get only root level categories
          const rootCategoryNames = result.trie.getSubcategoriesByPath([]);
          if (rootCategoryNames) {
            const categoryOptions = rootCategoryNames.map((categoryName: string) => ({
              label: categoryName,
              value: categoryName,
            }));
            setRootCategories(categoryOptions);
          }
        }
      } catch (error) {
        console.error('Failed to load categories:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadCategories();
  }, []);

  if (isLoading) {
    return <div>Loading categories...</div>;
  }

  return (
    <SearchableChipSelector
      options={rootCategories}
      value={value}
      onChange={onChange}
      placeholder={`Search and Add ${label}`}
      maxDisplayOptions={30}
    />
  );
};

export default CategorySelector;
